import { memoizedGet } from './object.esm.js';
import useResponsiveValue from '../hooks/use-responsive-value.esm.js';
import { useSafeThemeUI } from '../theme-provider/use-theme-ui.esm.js';
import { xxLargeResponsiveSizes, xLargeResponsiveSizes, largeResponsiveSizes, mediumResponsiveSizes, standardResponsiveSizes, smallResponsiveSizes, xSmallResponsiveSizes } from '../themes/const.esm.js';
import { isSizeKey } from '../themes/types.esm.js';

function getBodyFont(fontType) {
  switch (fontType) {
    case 'xs':
      return xSmallResponsiveSizes;
    case 'sm':
      return smallResponsiveSizes;
    case 'std':
      return standardResponsiveSizes;
    case 'md':
      return mediumResponsiveSizes;
    case 'lg':
      return largeResponsiveSizes;
    case 'xl':
      return xLargeResponsiveSizes;
    case 'xxl':
      return xxLargeResponsiveSizes;
  }
}
function getCurrentFontSize (fontType, size, theme) {
  var _theme = useSafeThemeUI({
    theme: theme
  });
  var sizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(fontType) ? memoizedGet(_theme, "headings.".concat(fontType, ".fontSize")) :
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getBodyFont(fontType);
  var value = size ? memoizedGet(_theme, "sizes.font.".concat(size)) : useResponsiveValue(sizes);
  var retVal = isSizeKey("".concat(value)) ? memoizedGet(_theme, "fontSizes.".concat(memoizedGet(_theme, "sizes.font.".concat(value)))) : memoizedGet(_theme, "fontSizes.".concat(value));
  return [retVal, "".concat(value)];
}

export default getCurrentFontSize;
//# sourceMappingURL=get-current-font-size.esm.js.map
